import BattleQuestion from "./BattleQuestion";

export default BattleQuestion;
